import { useEffect } from "react";
import { useRef } from "react";

export function useInterval(callback: Function, delay?: number) {
  const savedCallback = useRef<Function>();

  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  useEffect(() => {
    if (delay !== undefined) {
      const id = setInterval(() => savedCallback.current?.(), delay);

      return () => clearInterval(id);
    }
  }, [callback, delay]);
}